import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { MenuPosition } from './menu-position';

@Injectable()
export class PositioningService {
    public _renderer: Renderer2;
    constructor(
        rendererFactory: RendererFactory2
    ) {
        this._renderer = rendererFactory.createRenderer(null,null);
    }

    /**
     * Given an initial point and an element returns a point in which the element can fit on the screen without escaping
     * the bounds of the document.
     * @param point
     * @param element
     */
    public getPosition(point: Point, element: HTMLElement): Point {
        let elementBox = element.getBoundingClientRect();
        let documentBox = document.documentElement.getBoundingClientRect();
        let alteredPoint = Object.assign({}, point);

        if (point.y + elementBox.height >= documentBox.bottom - 20) {
            alteredPoint.y = point.y - elementBox.height;
            alteredPoint.y = alteredPoint.y <= documentBox.top ? documentBox.top : alteredPoint.y;
        }

        return alteredPoint;
    }

    /**
     * Gets the max height that an element can have without escaping the bounds of the document
     * @param element
     */
    public getMaxHeight(element: HTMLElement) {
        let elementBox = element.getBoundingClientRect();
        let documentBox = document.documentElement.getBoundingClientRect();
        
        return elementBox.bottom >= documentBox.bottom ? documentBox.bottom - elementBox.top - 20 : elementBox.height;
    }

    public setPosition(element: HTMLElement, point: Point, offsetX: number = 0, offsetY: number = 0) {
        this._renderer.setStyle(element, 'left', `${point.x + offsetX}px`);
        this._renderer.setStyle(element, 'top', `${point.y + offsetY}px`);
    }

    public setHeight(element: HTMLElement, height: number) {
        this._renderer.setStyle(element, 'height', `${height}px`);
    }

    /**
     * Gets an initial position for an element based upon its parent position and menu position parameters
     * @param parentElement
     * @param element
     * @param menuPosition
     */
    public getInitialPosition(parentElement: HTMLElement, element: HTMLElement, menuPosition: MenuPosition): Point {
        let point = { x: 0, y: 0 };
        if (menuPosition.position === 'before')
            point.x = parentElement.offsetLeft - element.offsetWidth;
        else
            point.x = parentElement.offsetWidth;

        if (menuPosition.verticalPosition === 'above')
            point.y = parentElement.offsetTop - element.offsetHeight;
        else if (menuPosition.verticalPosition === 'below')
            point.y = parentElement.offsetTop + parentElement.offsetHeight;
        else
            point.y = parentElement.offsetTop;
        return point;
    }
}

type Point = { x: number, y: number };
